export function coachingblocks(state) {
    return state.coachingBlocks;
}

export function upcomingEvent(state) {
    return state.upcomingEvent;
}

export function activeTimezone(state) {
    return state.activeTimezone;
}

export function activeCoachingblock(state) {
    return state.activeCoachingblock;
}
